function DropdownInputController () {
  var ctrl = this

  ctrl.$onInit = function () {
    $('.ui.dropdown.dropdown-input').dropdown({
      showOnFocus: false,
      selectOnKeydown: false,
      keys: {
        enter: false
      }
    })

    ctrl.$onChanges = ctrl.$onInit

    if (this.field.value && this.field.value.title) {
      $('.ui.dropdown.dropdown-input').dropdown('set selected', this.field.value.title)
    }
  }
}

export { DropdownInputController }
